import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Button,
} from "@mui/material";
import Grid from "@mui/material/GridLegacy";
  
import { CompensateIcon, MnageIcon, MonitorIcon, SimplyIcon, TrackIcon } from "../../icons";

// ✅ Add icon to each goal
const goals = [
  {
    title: "Monitor our employees",
    description:
      "Track time, see what your team is working on, view screenshots, and better understand how you can improve your performance, and more.",
    value: "monitor",
    icon: <MonitorIcon sx={{ fontSize: 28, color: "#1976d2" }} />,
  },
  {
    title: "Manage our schedules",
    description:
      "Set time off policies, approve and deny over time requests, and more.",
    value: "schedules",
    icon: <MnageIcon sx={{ fontSize: 28, color: "#1976d2" }} />,
  },
  {
    title: "Track our productivity",
    description:
      "See where our team can be more productive, decrease the risk of underworking and overpayment, improve team efficiency.",
    value: "productivity",
    icon: <TrackIcon sx={{ fontSize: 28, color: "#1976d2" }} />,
  }, 
  {
    title: "Compensate our staff",
    description:
      "Set pay rates, send payments to staff, connect with third-party payroll providers, and streamline back office operations.",
    value: "payments",
    icon: <CompensateIcon sx={{ fontSize: 28, color: "#1976d2" }} />,
  },
  {
    title: "Simply exploring",
    description:
      "Explore our range of features and discover the tools that will best enhance your team's productivity.",
    value: "exploring",
    icon: <SimplyIcon sx={{ fontSize: 28, color: "#1976d2" }} />,
  },
];

export default function GoalSelectionStep({ onNext, onBack }) {
 

  

  return (
    <Box sx={{ maxWidth: 900, mx: "auto", mt: 5 }}>
      <Typography variant="h6" gutterBottom>
        What do you want to get done?
      </Typography>
      <Typography variant="body2" mb={3}>
        Please select the option below that best describes what you're looking for. This will help customize your initial experience using Timetracker.
      </Typography>

      <Grid container spacing={2}>
        {goals.map((goal) => (
          <Grid item xs={12} sm={6} key={goal.value}>
            <Box 
              sx={{
                border:"1px solid #e0e0e0", 
                background:"#fff", 
                height: "100%",  
				borderRadius:'8px',
              }}
            >
              
                <CardContent sx={{}}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "start",
                      gap: 1.5,
                      mb: 1,
                    }}
                  >
                   <Box sx={{minWidth:'40px', maxWidth:'40px', height:'40px'}}>{goal.icon} </Box>
                  
				  <Box>
					 <Typography 
                      fontWeight="bold"
                      sx={{ fontSize: "16px", color:'#1A1F36' }}
                    >
                      {goal.title}
                    </Typography>
					<Typography variant="body2" sx={{fontSize:'14px', color:'#1A1F36'}}>{goal.description}</Typography>
				  </Box>
				  </Box> 
                </CardContent>
              
            </Box>
          </Grid>
        ))}
      </Grid>
	   {/* Buttons for this step */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 5 }}>
        <Button
          onClick={onBack}
          sx={{
            background: "#fff",
            color: "#595959",
            border: "1px solid #b8b8b8",
            textTransform: "capitalize",
            fontSize: "14px",
          }}
        >
          Back
        </Button>

        <Button
          onClick={onNext}
          sx={{
            background: "#0B57D0",
            color: "#fff",
            textTransform: "capitalize",
            fontSize: "14px",
            px: 3,
          }}
        >
          Start Now
        </Button>
      </Box>
    </Box>
  );
}
